import request from '@/utils/request'

/**
 * 获取所有权限
 * @returns
 */
export const getAllPermissionList = async (data) => {
  return await request({
    method: 'GET',
    url: '/sys/v1/permission/findAll',
    params: data
  })
}

/**
 * 获取指定角色的权限
 */
export const rolePermission = (roleId) => {
  return request({
    url: `/role/permission/${roleId}`
  })
}

/**
 * 添加新权限
 * @returns
 */
export const addPermission = async (data) => {
  return await request({
    method: 'POST',
    url: '/sys/v1/permission',
    data
  })
}

/**
 * 删除权限
 * @returns
 */
export const delPermission = async (id) => {
  return await request({
    method: 'DELETE',
    url: `/sys/v1/permission/${id}`
  })
}

/** 新增菜单权限 */
export const savePermissionMenu = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/menu/save',
    data
  })
}

/** 修改菜单权限 */
export const updatePermissionMenu = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/menu/update',
    data
  })
}

/** 删除菜单权限 */
export const deletePermissionMenu = (id) => {
  return request({
    method: 'DELETE',
    url: `/sys/v1/menu/delete/${id}`
  })
}
